import { ShipmentFinancials } from '@rygen/rygen-ui/model/shipmentFinancials';

import { ShipmentRelatedInvoiceReference } from '@/model';
import { ShipmentRateAllocation } from '@/model/shipmentFinancials';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment';

export class ShipmentFinancialsController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  buildUrl(shipmentId: number, extraPath = ''): string {
    if (!shipmentId) {
      throw new Error('Missing shipmentId');
    }

    return [`${shipmentId}/financials`, extraPath].join('/');
  }

  async getShipmentFinancialsById(
    shipmentId: number,
  ): Promise<ShipmentFinancials> {
    const response = await this.http.get<ShipmentFinancials>(
      this.buildUrl(shipmentId),
    );
    return new ShipmentFinancials(response.data);
  }

  async getShipmentInvoicesById(
    shipmentId: number,
  ): Promise<ShipmentRelatedInvoiceReference[]> {
    const response = await this.http.get<ShipmentRelatedInvoiceReference[]>(
      this.buildUrl(shipmentId, 'related-invoices'),
    );
    return response.data.map((val) => new ShipmentRelatedInvoiceReference(val));
  }

  async resyncShipmentFinancials(
    shipmentId: number,
  ): Promise<ShipmentFinancials> {
    const response = await this.http.post<ShipmentFinancials>(
      this.buildUrl(shipmentId, 'resync'),
    );
    return new ShipmentFinancials(response.data);
  }

  async getShipmentRateAllocationsOrderBatch(
    shipmentIds: number[],
    orderId: number,
  ): Promise<ShipmentRateAllocation[]> {
    const response = await this.http.post(
      '/financials/rate-allocation/order-batch',
      { shipmentIds, orderId },
    );

    return response.data.map(
      (val: ShipmentRateAllocation) => new ShipmentRateAllocation(val),
    );
  }

  async getShipmentRateAllocation(
    shipmentId: number,
  ): Promise<ShipmentRateAllocation> {
    const response = await this.http.get(
      this.buildUrl(shipmentId, 'rate-allocation'),
    );

    return new ShipmentRateAllocation(response.data);
  }

  async recalculateShipmentRateAllocation(
    shipmentId: number,
    rateAllocation: ShipmentRateAllocation,
  ): Promise<ShipmentRateAllocation> {
    const response = await this.http.post(
      this.buildUrl(shipmentId, 'rate-allocation/recalculate'),
      rateAllocation,
    );

    return new ShipmentRateAllocation(response.data);
  }

  async updateShipmentRateAllocation(
    shipmentId: number,
    rateAllocation: ShipmentRateAllocation,
  ): Promise<ShipmentRateAllocation> {
    const response = await this.http.put(
      this.buildUrl(shipmentId, 'rate-allocation'),
      rateAllocation,
    );

    return new ShipmentRateAllocation(response.data);
  }
}
